import { Sutl } from '../../../../sutl';
import { Observable } from './Observable';
export class CallParticipantsState {
    constructor(logFactory) {
        this.observable = new Observable();
        this._values = {};
        this.log = logFactory.channel('CallParticipantsState');
    }
    get values() {
        return this._values;
    }
    clear(callKey) {
        delete this._values[callKey]; // don't notify observers
    }
    getParticipant(callKey, participantKey, errorIfUndefined = false) {
        const participants = this._values[callKey];
        if (participants === undefined) {
            if (errorIfUndefined)
                this.log.error(`no participants for call ${callKey}`);
            return undefined;
        }
        const participant = participants[participantKey];
        if (participant === undefined) {
            if (errorIfUndefined)
                this.log.error(`no participant with key ${participantKey}`);
            return undefined;
        }
        return participant;
    }
    setParticipant(callKey, participantKey, callback) {
        var _a;
        if (participantKey === '*') {
            const participants = this._values[callKey];
            if (participants === undefined)
                return;
            const newParticipants = {};
            for (const [participantKey, participant] of Object.entries(participants)) {
                const newParticipant = (_a = callback(participant)) !== null && _a !== void 0 ? _a : Object.assign({}, participant);
                newParticipants[participantKey] = newParticipant;
            }
            this.updateParticipants(callKey, newParticipants);
        }
        else {
            const participant = this.getParticipant(callKey, participantKey, true);
            if (participant === undefined)
                return;
            const newParticipant = callback(participant);
            if (newParticipant !== undefined) {
                this.updateParticipant(callKey, participantKey, newParticipant);
            }
        }
    }
    mute(callKey, participantKey, value) {
        this.setParticipant(callKey, participantKey, participant => {
            return participant.audioMuted === value
                ? undefined
                : Object.assign(Object.assign({}, participant), { audioMuted: value });
        });
    }
    muteVideo(callKey, participantKey, value) {
        const sendingVideo = !value;
        this.setParticipant(callKey, participantKey, participant => {
            return participant.sendingVideo === sendingVideo
                ? undefined
                : Object.assign(Object.assign({}, participant), { sendingVideo });
        });
    }
    spotlight(callKey, participantKey, value) {
        this.setParticipant(callKey, participantKey, participant => {
            return participant.spotlighted === value
                ? undefined
                : Object.assign(Object.assign({}, participant), { spotlighted: value });
        });
    }
    subscribe(callback, end = true) {
        return this.observable.subscribe(callback, end);
    }
    unsubscribe(id) {
        this.observable.unsubscribe(id);
    }
    unsubscribeAll() {
        this.observable.unsubscribeAll();
    }
    updateParticipant(callKey, participantKey, participant) {
        var _a, _b;
        if (Sutl.objEquals((_a = this._values[callKey]) === null || _a === void 0 ? void 0 : _a[participantKey], participant))
            return;
        const event = Object.assign({ callKey,
            participantKey, type: 'participantChanged' }, (participant ? { value: participant } : undefined));
        if (participant === undefined) {
            (_b = this._values[callKey]) === null || _b === void 0 ? true : delete _b[participantKey];
        }
        else {
            if (this._values[callKey] === undefined)
                this._values[callKey] = {};
            this._values[callKey][participantKey] = participant;
        }
        this.observable.notifyListeners(event);
    }
    updateParticipants(callKey, participants) {
        if (Sutl.objEquals(this._values[callKey], participants))
            return;
        const event = Object.assign({ callKey, type: 'participantsChanged' }, (participants ? { value: participants } : undefined));
        if (participants === undefined) {
            delete this._values[callKey];
        }
        else {
            this._values[callKey] = participants;
        }
        this.observable.notifyListeners(event);
    }
}
